<template>
	<div class="applylist">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="list">
        <div class="listitem" v-for="item of list">
          <div class="head flex-ac">
            <img class="flex-s" :src="item.headimg" @error="function (event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
            <div class="nickname flex-1">
              <p class="f14">{{item.name}}</p>
              <span class="f10">{{item.time}}</span>
            </div>
          </div>
          <p class="content f12">{{item.content}}</p>
          <div class="footer flex-js-ac">
            <button class="btn1 f12 color-FC0324" v-if="item.linkitemid" @click="godetail(item)">查看商品</button>
            <div v-else></div>
            <button class="btn2 f10 flex-ac color-9" @click="likeFn(item)">
              <img :src="item.ifpraise == 0 ? '/static/images/community/notlike.png' : '/static/images/community/like.png'">&nbsp;{{item.praisenum}}
            </button>
          </div>
        </div>
      </div>
    </Scroller>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
export default {
  name: 'applylist',
  components: {
    Scroller
  },
  data () {
    return {
      list: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      pagesize: 10,
      noDataText: ''
    }
  },
  methods: {
    getData: function () {
      let url = 'Wxmall/NewItem/getApply?pageNo=' + this.nowPage + '&pageSize=' + this.pagesize + '&actid=' + this.$route.query.actid
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          let list = []
          list = res.data.list
          if (this.nowPage == 1) {
            this.list = list
            this.refresh = false
            this.$forceUpdate()
          } else {
            this.list = this.list.concat(list)
            this.$forceUpdate()
          }
          this.loading = false
          this.finished = list.length < this.pagesize
          if (this.nowPage == 1 && list.length == 0) this.empty = true
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      this.nowPage++
      this.getData()
    },
    godetail (item) {
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: item.linkitemid
        }
      })
    },
    likeFn (item) {
      var url = 'Wxmall/NewItem/applyLikes', data = {
        applyid: item.applyid
      }, that = this
      this.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code == 200) {
          f(item)
        }
      })
      function f (item) {
        if (item.ifpraise == 0) {
          item.ifpraise = 1
          item.praisenum++
        } else {
          item.ifpraise = 0
          item.praisenum--
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .applylist {
    margin: 0.1rem 0.11rem;
    .list {
      .listitem {
        margin-top: 0.1rem;
        background: #ffffff;
        border-radius: 0.03rem;
        padding: 0.15rem 0.11rem;
        &:first-of-type {
          margin-top: 0;
        }
        .head {
          img {
            width: 0.34rem;
            height: 0.34rem;
            border-radius: 50%;
            margin-right: 0.1rem;
          }
          .nickname {
            p {
              color: #333333;
            }
            span {
              color: #999999;
              display: block;
            }
          }
        }
        .content {
          color: #333333;
        }
        .footer {
          margin-top: 0.1rem;
          button {
            outline: none;
            background: transparent;
            border-width: 0;
            &.btn2 {
              img {
                width: 0.14rem;
                height: 0.14rem;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/newproducttrial/applylist.vue